import { Route, Routes } from "react-router-dom"
import { Activities, ActivityItems } from "../pages/activities"
import { BathchesShipped, Details } from "../pages/bathchesShipped"
import { Courses } from "../pages/courses"
import { CoursesItems } from "../pages/courses/CoursesItems"
import { Excelpoc } from "../pages/excel"
import { Groups } from "../pages/groups"
import { GroupsItems } from "../pages/groups/GroupsItems"
import { Materials } from "../pages/materials"
import { OpenBatches } from "../pages/openBatches"
import { SubActivities, SubActivityItems } from "../pages/subActivities"
import { Transactions } from "../pages/transactions"
import { WorkCenter } from "../pages/worksCenter"

export const MainRoutes = () => {
    return (
        <Routes>
            <Route path="materials" element={<Materials entity="materials" />} />
            <Route path="activities" element={<Activities />} />
            <Route path="subactivities" element={<SubActivities />} />
            <Route path="courses" element={<Courses />} />
            <Route path="groups" element={<Groups />} />
            <Route path="subActivities/:id" element={<SubActivityItems />} />
            <Route path="activities/:id" element={<ActivityItems />} />
            <Route path="courses/:id" element={<CoursesItems />} />
            <Route path="groups/:id" element={<GroupsItems />} />
            <Route path="inventoryTracking" element={<Transactions />} />
            <Route path="excelpoc" element={<Excelpoc />} />
            <Route path="openBatches/:id" element={<OpenBatches />} />
            <Route path="workCenter" element={<WorkCenter />} />
            <Route path="bathchesShipped" element={<BathchesShipped />} />
            <Route path="bathchesShipped/details/:id" element={<Details />} />
            {/* <RouteGuard exact path="/" component={PrivateComponent} groups={[groups.Admin, groups.User,]} /> */}
        </Routes>
    )
}
